import { render, staticRenderFns } from "./SidebarGroupContent.vue?vue&type=template&id=688e3886&scoped=true&"
import script from "./SidebarGroupContent.vue?vue&type=script&lang=ts&"
export * from "./SidebarGroupContent.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarGroupContent.vue?vue&type=style&index=0&id=688e3886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688e3886",
  null
  
)

export default component.exports